import { membershipDTOSchema, } from '@instanexus/contracts';
import { listEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const listMembershipsSchema = listEnvelopeSchema(membershipDTOSchema);
export function createMembershipsResource(transport) {
    return {
        async list(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/memberships`,
                schema: listMembershipsSchema,
                query: { page: params.page, pageSize: params.pageSize, sort: params.sort },
            });
        },
    };
}
//# sourceMappingURL=memberships.js.map